import { render } from "./Selector.vue?vue&type=template&id=9c88c6f8&scoped=true"
import script from "./Selector.vue?vue&type=script&lang=js"
export * from "./Selector.vue?vue&type=script&lang=js"

import "./Selector.vue?vue&type=style&index=0&id=9c88c6f8&scoped=true&lang=stylus"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c88c6f8"]])

export default __exports__